import { getArrivals, postNewGuest } from 'actions/arrivals'
import AddGuestButton from 'components/ReusableComponents/Arrivals/AddGuestButton'
import AddGuestWithPhone from 'components/ReusableComponents/Arrivals/AddGuestWithPhone/index'
import AddGuestWithRoomNo from 'components/ReusableComponents/Arrivals/AddGuestWithRoomNo/index'
import ArrivalList from 'components/ReusableComponents/Arrivals/ArrivalList/index'
import MatchingGuestDialog from 'components/ReusableComponents/Arrivals/MatchinGuestDialog/index'
import MessagingSetupDialog from 'components/ReusableComponents/Arrivals/MessagingSetupDialog/index'
import CustomHeader from 'components/ReusableComponents/HeaderTitles/index'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import usePlausible from 'hooks/usePlausible'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'

const Arrivals = ({ noList }) => {
  const [showSetupDialog, setShowSetupDialog] = useState(false)
  const [showAddGuestWithPhone, setShowAddGuestWithPhone] = useState(false)
  const [showAddGuestWithRoom, setShowAddGuestWithRoom] = useState(false)
  const [showFindMatchDialog, setShowFindMatchDialog] = useState(false)
  const [activeGuest, setActiveGuest] = useState({})
  const [matchingGuest, setMatchingGuest] = useState({})
  const [newGuestRoom, setNewGuestRoom] = useState()

  const [arrivingGuestsCount, setArrivingGuestsCount] = useState()
  const [inHouseGuestsCount, setInHouseGuestsCount] = useState()

  const dispatch = useDispatch()

  const { arrivals, loading, error } = useSelector(s => s.arrivals)

  useEffect(() => {
    if (arrivals && arrivals.length > 0) {
      const arrivingGuestsCount = arrivals.filter(a => a.status === 'InUse').length
      setInHouseGuestsCount(arrivingGuestsCount)
      setArrivingGuestsCount(arrivals.length - arrivingGuestsCount)
    } else {
      setInHouseGuestsCount(0)
      setArrivingGuestsCount(0)
    }
  }, [arrivals])

  const lastPostedGuest = useSelector(s => s.arrivals.lastPostedGuest)

  const { currentHotel } = useSelector(s => s.login)

  const { addToast } = useToasts()

  useEffect(() => {
    if (lastPostedGuest) {
      addToast(
        `Chat with ${lastPostedGuest.guestFirstName} ${lastPostedGuest.guestLastName} started succesfully!`,
        {
          appearance: 'success',
          autoDismiss: true
        }
      )

      setActiveGuest('')
    }
  }, [addToast, lastPostedGuest])

  useEffect(() => {
    if (error) {
      addToast(`${error}`, {
        appearance: 'error',
        autoDismiss: true
      })

      setActiveGuest('')
    }
  }, [addToast, error])

  const { postEvent, plausibleEvents } = usePlausible()

  function handleSetupClick(id) {
    postEvent(plausibleEvents.StartChatFromArrivals, {
      id
    })

    const foundGuest = arrivals.find(a => a.subscriberHotelBookingId === id)
    const {
      guestFirstName,
      guestLastName,
      phoneNumber,
      roomNumber,
      subscriberHotelBookingId
    } = foundGuest

    if (guestFirstName && guestLastName && phoneNumber) {
      dispatch(
        postNewGuest({
          guestFirstName,
          guestLastName,
          guestPhoneNumber: phoneNumber,
          guestPhoneCountryCode: '1',
          roomNumber,
          bookingId: subscriberHotelBookingId
        })
      )
    } else {
      setActiveGuest(foundGuest)
      setShowSetupDialog(true)
    }
  }

  function handleNewGuestSubmit(newGuestRoom) {
    setNewGuestRoom(newGuestRoom)
    const match = arrivals.find(a => a.roomNumber === newGuestRoom)

    setShowAddGuestWithRoom(false)

    if (match) {
      setMatchingGuest(match)
      setShowFindMatchDialog(true)
    } else {
      setActiveGuest({ roomNumber: newGuestRoom })
      setShowSetupDialog(true)
    }
  }

  function handleAddGuestClick() {
    postEvent(plausibleEvents.StartChatFromArrivals)

    setShowAddGuestWithRoom(true)
  }

  function handleSetupGuest(guestInfo) {
    setShowSetupDialog(false)

    const { guestFirstName, guestLastName, guestPhoneNumber, roomNumber } = guestInfo

    dispatch(
      postNewGuest({
        guestFirstName,
        guestLastName,
        guestPhoneNumber,
        guestPhoneCountryCode: '1',
        roomNumber
      })
    )
  }

  function confirmMatchingGuest() {
    setActiveGuest(matchingGuest)
    setMatchingGuest(null)
    setShowSetupDialog(true)
    setShowFindMatchDialog(false)
  }

  function rejectMatchingGuest() {
    setActiveGuest({ roomNumber: newGuestRoom })
    setMatchingGuest(null)
    setShowSetupDialog(true)
    setShowFindMatchDialog(false)
  }

  useEffect(() => {
    dispatch(getArrivals())
  }, [currentHotel, dispatch])

  return (
    <>
      {noList ? (
        <>{loading ? null : <AddGuestButton mini onClick={handleAddGuestClick} />}</>
      ) : (
        <>
          <CustomHeader title="Arrivals &amp; In-house" width={1080} isFixed />
          {loading && <LoadingIndicator />}
          {!loading && (
            <ArrivalList
              arrivals={arrivals}
              handleAddGuestClick={handleAddGuestClick}
              handleSetupClick={handleSetupClick}
              inHouse={inHouseGuestsCount}
              todaysArrivals={arrivingGuestsCount}
            />
          )}
        </>
      )}
      {showSetupDialog && (
        <MessagingSetupDialog
          handleConfirm={handleSetupGuest}
          handleCancel={() => setShowSetupDialog(false)}
          {...activeGuest}
        />
      )}
      {showAddGuestWithPhone && (
        <AddGuestWithPhone
          handleClose={() => setShowAddGuestWithPhone(false)}
          handleSubmit={handleNewGuestSubmit}
        />
      )}
      {showAddGuestWithRoom && (
        <AddGuestWithRoomNo
          handleClose={() => setShowAddGuestWithRoom(false)}
          handleSubmit={handleNewGuestSubmit}
        />
      )}
      {showFindMatchDialog && matchingGuest && (
        <MatchingGuestDialog
          handleSubmit={confirmMatchingGuest}
          handleCancel={rejectMatchingGuest}
          {...matchingGuest}
        />
      )}
    </>
  )
}

export default Arrivals
